import type { PIIString } from '@trello/privacy';
import { convertToPIIString } from '@trello/privacy';
import { importWithRetry } from '@trello/use-lazy-component';

import { renderPage } from './renderPage';
import { userOrOrgPage } from './userOrOrgProfilePage';

const getMemberAccountPage = function (username: PIIString) {
  username = convertToPIIString('me');
  return renderPage(
    importWithRetry(
      () =>
        import(
          /* webpackChunkName: "member-account-page-controller" */ './memberAccountPageController'
        ),
    ).then(({ memberAccountPageController }) =>
      memberAccountPageController({
        username,
      }),
    ),
  );
};

export const userOrOrgAccountPage = function (name: PIIString | string) {
  // eslint-disable-next-line eqeqeq
  if (name == null) {
    name = 'me';
  }
  // @ts-expect-error TS(2554): Expected 5 arguments, but got 4.
  userOrOrgPage.call(
    // @ts-expect-error
    this,
    name,
    // @ts-expect-error
    getMemberAccountPage.bind(this),
    // @ts-expect-error
    this.organizationAccountView.bind(this),
  );
};
